var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    { staticClass: "sub-menu md-3", attrs: { "slider-color": "primary" } },
    [
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/organizational-structure", exact: "" }
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("settings.organisationStructure.menu.mainSettings")
              ) +
              " "
          )
        ]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/organizational-structure/users" }
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("settings.organisationStructure.menu.userSettings")
              ) +
              " "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }